import { motion, useReducedMotion } from "framer-motion";
import { Eyebrow, Reveal, EASE } from "./Reveal";

const STEPS = [
    {
        n: "01",
        t: "Discover",
        c: "Find fashion through intelligent search, visual discovery and curated inspiration.",
    },
    {
        n: "02",
        t: "Refine",
        c: "Explore alternatives, compare styles and discover pieces across different budgets.",
    },
    {
        n: "03",
        t: "Shop",
        c: "Go directly to your favourite retailers to purchase the pieces you love.",
    },
];

export default function HowItWorks() {
    const reduce = useReducedMotion();
    return (
        <section id="how-it-works" className="bg-white pb-24 md:pb-36" data-testid="how-it-works-section">
            <div className="mx-auto max-w-[1320px] px-6 sm:px-10 lg:px-16">
                <Reveal>
                    <Eyebrow>How EDIT works</Eyebrow>
                </Reveal>
                <div className="mt-14 grid grid-cols-1 gap-14 md:grid-cols-3 md:gap-10 lg:gap-16">
                    {STEPS.map((s, i) => (
                        <div key={s.n} className="flex flex-col">
                            <motion.div
                                className={`h-px w-full bg-slate-200 ${i > 0 ? "hidden md:block" : ""}`}
                                initial={reduce ? { scaleX: 1 } : { scaleX: 0 }}
                                whileInView={{ scaleX: 1 }}
                                viewport={{ once: true, amount: 0.4 }}
                                transition={{ duration: 1.2, delay: i * 0.15, ease: EASE }}
                            />
                            <Reveal delay={0.1 + i * 0.1} className="pt-10">
                                <span className="block text-[5.5rem] font-extralight leading-none tracking-tight text-slate-200 md:text-[7rem]">
                                    {s.n}
                                </span>
                                <h3 className="mt-6 text-2xl font-light tracking-tight text-slate-950">{s.t}</h3>
                                <p className="mt-4 max-w-xs text-base font-extralight leading-relaxed text-slate-600">
                                    {s.c}
                                </p>
                            </Reveal>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
